<template lang="pug">
  v-col(cols="12")
    v-row
    v-col(cols="4" md="4" xs="12" sm="12")
      h2.text-center Puntuaciones

      v-simple-table
        template
          thead
            tr
              th
              th
              th
          tbody
            tr(v-for="number in 15")
              td Nombre
              td  ID
              td {{number}}
    v-col(cols="8" md="8" xs="12"  sm="12" style="background:@/assets/field.png")
      v-card
        v-card-title
          h2 Josué
        v-card-text
          h3.text-left Jugadores 5/5
          h3.text-right Presupuesto Restante
            h2.green--text 550M
      v-row.pa-10(align="center" justify="center")
        v-col(cols="3" v-for="(test,i) in 5" :key="i")
          v-card
            v-row.px-5
              v-col(cols="6" xs="12" sm="12" md="8")
                h3 Neymar
              v-col.text-right(cols="6"  xs="12" sm="12" md="4")
                h3 1{{test}}
              v-col(cols="12")
                h2.green--text 58,70€

</template>

<script>
  export default {
    name: "ContestRatings"
  }
</script>

<style lang="sass">
</style>